jQuery('.faq-strip').on('click touch', function() {
    jQuery('.faq-strip').not(this).removeClass('open');
    jQuery(this).toggleClass('open');
});

jQuery('#faqContactButton').click(function() {
    $('html, body').animate({
        scrollTop: $("#contact").offset().top - 100
    }, 200);
});